export const userManagement = {
  enumController: {
    getEnumData: "/enums",
    getEnumDataFromCode: "/enums/",
    saveEnumData: "/enums/enums",
    updateEnumData: "/enums/enums/",
  },
  loginController: {
    login: "/login",
    logout: "/logout",
    saveMerchant: "/registerMerchant",
    loginSendOtp: "/login/sendOtp",
    loginVerifyOtp: "/login/verifyOtp",
    ssoLogin: "/ssoLogin",
    googleAuthDetails: "https://www.googleapis.com/oauth2/v3/userinfo",
  },
  permissionController: {
    getPermissions: "/permissions",
  },
  HomePageController: {
    getData: "/homepage/getData",
    getCityData: "/homepage/getCityData",
  },
  userController: {
    addUser: "/users",
    findUserById: "/users/",
    updateUser: "/users/",
    deleteUser: "/users/",
    getUsers: "/users/",
    forgotPassword: "/users/forgotPassword",
    resetPassword: "/users/resetPassword",
    uploadUsers: "/users/upload",
    findUsername: "/users/username/",
  },
};

export const spotFinder = {
  BlogController: {
    findBlogBySearch: "/blogs/search",
    findBlogDetailById: "/blogs/findById",
  },
  emailController: {
    sendEmailLink: "/email/sendEmailLink/",
  },
  cityController: {
    getAllCities: "/cityData/getAllCities",
  },
  contactSupportController: {
    addQueryContact: "/contactSupport/addQueryContact",
  },
  serviceProviderDetailController: {
    getAllServiceProviderDetail: "/serviceProviderDetail/findAll/",
    findServiceProviderDetailById: "/serviceProviderDetail/findById/",
    findServiceProviderDetailByUserId: "/serviceProviderDetail/findByUserId/",
    saveServiceProviderDetail: "/serviceProviderDetail/save",
    updateServiceProviderDetail: "/serviceProviderDetail/update",
    deleteServiceProviderDetail: "/serviceProviderDetail/delete/",
  },
  QRCodeController: {
    generateQRCode: "/generateQRCode/generateQRCode/",
  },
  bookingDetailController: {
    findByBookingId: "/bookingDetail/findByBookingId",
    getAllBookingDetailBySearchCriteria:
      "/bookingDetail/getAllBookingDetailBySearchCriteria",
    saveBookingDetail: "/bookingDetail/save",
    updateBookingDetail: "/bookingDetail/update",
    cancelBooking: "/bookingDetail/cancelBooking",
    updateActualTime: "/bookingDetail/updateActualTime",
    findByBookingCodeAndEmail: "/bookingDetail/findByBookingCodeAndEmail",
    completeBookingDetail: "/bookingDetail/complete",
  },
  parkingSpaceLocationController: {
    findAllServiceDetail: "/parkingSpaceLocation/findAll",
    findParkingSpaceLocationById: "/parkingSpaceLocation/findById/",
    getAllParkingSpaceLocation:
      "/parkingSpaceLocation/getAllParkingSpaceLocationBySearchCriteria",
    getAllParkingSpaceLocationByLatLongAndCity:
      "/parkingSpaceLocation/getAllParkingSpaceLocationByLatLongAndCity",
  },
  parkingTypeController: {
    getParkingTypeData: "/parkingType/getData",
  },
  customerFavouriteController: {
    deleteCustomerFavourite: "/customerFavourite/delete",
    findAllCustomerFavourite: "/customerFavourite/findAll",
    findFavouriteByCustomerId: "/customerFavourite/findByCustomerId",
    saveCustomerFavourite: "/customerFavourite/save",
    updateCustomerFavourite: "/customerFavourite/update",
  },
  cartDetailController: {
    findByCustomerId: "/cartDetail/findByCustomerId",
    saveCartDetail: "/cartDetail/save",
    updateCartDetail: "/cartDetail/update",
    findByCartId: "/cartDetail/findByCartId",
    deleteCartDetailItem: "/cartDetail/delete",
  },
  calculateBillingRateController: {
    calculateBillingRate: "/calculateBillingRate",
    applyCoupon: "/applyCoupon",
    saveAuditLog: "/auditLog/save",
    calculateExtraBillingRate: "/calculateExtraBilling",
  },
  serviceProviderFeedbackController: {
    getAllServiceProviderFeedback:
      "/serviceProviderFeedback/findAllWithPagination",
    findServiceProviderFeedbackById: "/serviceProviderFeedback/findById/",
    findServiceProviderDetailByParkingId:
      "/serviceProviderFeedback/findByParkingId/",
    saveServiceProviderFeedback: "/serviceProviderFeedback/save",
    updateServiceProviderFeedback: "/serviceProviderFeedback/update",
  },
  RLRestController: {
    getAmenities: "/reservationLabs/amenities",
    getCostOfLocationType: "/reservationLabs/costOfLocationType",
  },
  customerDetailController: {
    saveCustomerDetail: "/customer/save",
    updateCustomerDetail: "/customer/update",
    findCustomerDetailByUserId: "/customer/findByUserId",
    findCustomerDetailById: "/customer/findById",
    uploadCustomerImage: "/customer",
    findByCustomerId: "/customer/findById",
    deleteCustomerImage: "/customer/deleteProfile",
  },
  contactUsController: {
    addQueryContactUs: "/contactSupport/addQueryContact",
  },
  offerDetailController: {
    getAllOfferDetail: "/coinOfferDetail/findAll",
  },
  customerBalanceController: {
    updateCustomerBalance: "/customerBalance/update",
    findCustomerBalanceByUserId: "/customerBalance/findByUserId/",
    getWalletHistory: "/customerBalance/walletHistory/",
  },

  customerFeedbackController: {
    deleteCustomerFeedback: "/customerFeedback/delete",
    findAllCustomerFeedback: "/customerFeedback/findAll",
    getAllCustomerFeedback: "/customerFeedback/findAllWithPagination",
    findCustomerFeedbackById: "/customerFeedback/findById",
    saveCustomerFeedback: "/customerFeedback/save",
    updateCustomerFeedback: "/customerFeedback/update",
    findCustomerFeedbackByBookingId:"/customerFeedback/findByBookingId",

  },
  
  invoiceDetailController: {
    findByCustomerId: "/invoiceDetail/findByCustomerId",
    downloadInvoice:"/invoiceDetail/download",

  },
  pdfExportController: {
    exportToPDF: "/ExportToPdf/DownloadPdf/",
  },
  StripeController: {
    paymentWithCheckoutPage: "/payment",
  },
  CashfreeController: {
    createOrder: "/cashfree/order",
    getOrder: "/cashfree/order/",
    createCustomer:"/cashfree/customer"
  },
  PaymentMethodController: {
    getAllPaymentMethod: "/paymentMethod/getAllPaymentMethod",
  },
  RazorpayController: {
    createOrderRazorpay: "/razorpay/createOrder",
  },
  PaymentController: {
    getTicketIntention: "/orderpay/ticket",
    getTransactionIntention: "/orderpay/transaction",
  },
  VehicleCategoryController: {
    getCategoryList: "/vehicle/category",
  },
  CustomerVehicleController: {
    saveCustomerVehicleDetail: "/customerVehicle/save",
    updateCustomerVehicleDetail: "/customerVehicle/update",
    searchCustomerVehicleDetail: "/customerVehicle/search",
    deleteCustomerVehicleDetail: "/customerVehicle/delete/",
  },

  paymentController: {
    encPaymentString: "/ccavenuepay/orderPaymentDtls",
  },

  SubBookingDetailController: {
    getByBookingId: "/subBookingDetail/getByBookingId",
  },
};
